import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { AppTaskId } from "@shared";

// ═══════════════════════════════════════════════════════════
// App Tasks Hook — POST /api/admin/tasks/run-all
// ═══════════════════════════════════════════════════════════

export interface RunAllTasksResult {
  ran: Array<{ taskId: AppTaskId; success: boolean; error?: string }>;
  pendingAfter: AppTaskId[];
}

/**
 * Mutation hook to trigger all pending data tasks for the current tenant.
 * On success, invalidates the settings query so PendingTasksBanner disappears.
 */
export function useRunPendingTasks() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post<RunAllTasksResult>("/api/admin/tasks/run-all", {}),
    onSuccess: () => {
      // Re-fetch settings so pendingTaskIds is refreshed → banner disappears
      void queryClient.invalidateQueries({ queryKey: queryKeys.settings });
    },
  });
}
